module.exports = __webpack_public_path__ + "static/media/root_beer_hero.5a988f57.jpg";